
import FormatterService from '@/service/FormatterService';

export default {
    name: 'MarketSummaryCard',

    props: {
        marketSummaryContent: {
            type: String,
            default: ''
        },
        createdAt: {
            type: String,
            default: ''
        },
        isLoading: {
            type: Boolean,
            default: false,
        }
    },

    computed: {
        displayedCreatedAt() {
            if (!this.createdAt) {
                return '';
            }

            const dateOpt = {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
                hour12: false
            };
            const dateLocale = {
                'en': 'en-CA',
                'de': 'de-DE',
                'fr': 'fr-FR',
                'es': 'es-ES',
            };
            const locale = this.$getCurrentLocale();

            return this.format.date({ locale: dateLocale[locale], date: this.createdAt }, dateOpt);
        },
        finAgentLink() {
            if (this.isSubscribedFinAgent || (this.isFreePlan && !this.isReachFreePlanLimit)) {
                return this.$getTranslatedRoutePath('/fin-agent/');
            }

            if (this.isFreePlan && this.isReachFreePlanLimit) {
                return {
                    name: this.$getTranslatedRouteName('subscription'),
                    params: { plan: subscriptionPlans.ai }
                };
            }

            return this.$getTranslatedRoutePath('/fin-agent/');
        },
        finAgentIconPath() {
            return this.$vuetify.theme.dark ?
                require('@/assets/icons/sparkles-dark.svg') :
                require('@/assets/icons/sparkles-light.svg');
        },
    },

    created() {
        this.format = new FormatterService();
    }
}
